import NotFoundGeneric from "./NotFoundGeneric";

export default NotFoundGeneric;
